import Loading from './loading.vue'
let vm = {}

export default {
  install (Vue, opts) {
    opts = opts || {}
    const LoadingPlugin = Vue.extend(Loading)
    vm = new LoadingPlugin({
      data: opts
    }).$mount()
    document.body.appendChild(vm.$el)
    // Vue.prototype.$loading = (loading) => vm.loading = loading
    Vue.prototype.$loading = LoadingPlugin
  }
}
export const asyncLoading = function (fn) {
  return new Promise((resolve, reject) => {
    vm.loading = true
    const finished = cb => { return (result) => { cb(result); vm.mbloading = false } }
    fn.then(finished(resolve)).catch(finished(reject))
  })
}



// WEBPACK FOOTER //
// ./src/plugins/mbloading/index.js